module.exports = __webpack_public_path__ + "static/media/queen-berry-icon.f6532232.png";